import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import InputField from "../../components/form/InputField";
import { changePassword, logout } from "../../features/userSlice";
import { closeModal } from "../../features/modalSLice";
import { useNotification } from "../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { resetPasswordSchema } from "../../schemas";

const ChangePassword = ({ id }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(resetPasswordSchema) });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(changePassword({ id, data }));
      if (changePassword.fulfilled.match(res)) {
        addNotification("Password Changed successfully", "success");
        dispatch(closeModal());
        dispatch(logout());
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <div className=" min-w-[85vw] sm:min-w-[35rem] lg:min-w-[40]">
      <div className="    py-6 border-b border-bkg2 mb-4 text-text-1/90">
        <h4>Change Password</h4>
      </div>
      <form typeof="submit" onSubmit={handleSubmit(onSubmit)}>
        <InputField
          register={register}
          label="Old Password"
          name="old_password"
          errors={errors.old_password}
          type="password"
        />
        <div className="py-5" />
        <InputField
          register={register}
          label="New Password"
          name="password"
          errors={errors.password}
          type="password"
        />
        <InputField
          register={register}
          label="Confirm Password"
          name="confirm_password"
          errors={errors.confirm_password}
          type="password"
        />
        <ResourseButtons submitText="Save" />
      </form>
    </div>
  );
};

export default ChangePassword;
